// Is this document a widget embed?
//
// Widget embeds run inside a cross-site iframe on somebody else's website,
// and that context has one property that matters enormously here: browsers
// deny third-party storage access. Clerk reads localStorage as it
// initialises, so on an embedder's page it throws
//
//   SecurityError: Failed to read the 'localStorage' property from 'Window'
//
// never finishes loading, and AuthProvider's `if (!isLoaded)` gate then blocks
// the whole render behind a "Connecting..." spinner forever. Every embed on
// every third-party site hung, in both the script-tag and plain-iframe forms.
//
// It stayed invisible because nothing we own reproduces it: the landing page
// renders widgets in-page, and a karbonkit.com -> widgets.karbonkit.com iframe
// is SAME-site, so its storage is not partitioned. Only a genuine third-party
// domain triggers it -- which is to say, only real customers.
//
// Widgets need no authentication at all (the config id is the bearer token,
// resolved server-side), so index.js and App.js both use this to give the
// widget route a tree with neither ClerkProvider nor AuthProvider. That also
// keeps Clerk's JS off the critical path for every embedder.
//
// Read from window.location rather than a router hook: index.js has to decide
// before any Router exists.
export const WIDGET_ROUTE = '/widget-embed';

export function isWidgetRoute(pathname) {
  const path =
    pathname != null
      ? pathname
      : (typeof window !== 'undefined' && window.location
          ? window.location.pathname
          : '');
  return path === WIDGET_ROUTE || path === `${WIDGET_ROUTE}/`;
}
